export default __webpack_public_path__ + "static/media/Group 1171276529.d7bc9b0e.svg";